var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwipinghand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 183 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hand-group outline-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3 115.3L82.4 109.2C84.8 104.5 90.6 102.6 95.3 105C100 107.4 101.9 113.2 99.5 117.9L96.4 124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 136.5C114 131.8 119.8 129.9 124.5 132.3C129 134.6 130.4 140.4 127.5 144.5L109.3 170.3L101.8 180.9C88.9 201.7 61.6 208 40.9 195.1C20.1 182.2 13.8 154.9 26.7 134.2L29.3 129L38.9 110.1C41 106.1 45.9 104.5 50 106.5L59.8 111.5L85.4 61.4999C87.8 56.7999 93.6 54.8999 98.3 57.2999C103 59.6999 104.9 65.4999 102.5 70.1999L80.7 112.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "arrow-group outline-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8 47.3C53 35.6 75.5 28.8 99.6 28.8C122.3 28.8 144.1 34.9001 162.5 45.4001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 20L162.4 45.4L136.6 53.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "hand-group stroke-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7 111.5L52.3 126.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 136.5C114 131.8 119.8 129.9 124.5 132.3C129 134.6 130.4 140.4 127.5 144.5L109.3 170.3L101.8 180.9C88.9 201.7 61.6 208 40.9 195.1C20.1 182.2 13.8 154.9 26.7 134.2L29.3 129L38.9 110.1C41 106.1 45.9 104.5 50 106.5L59.8 111.5L85.4 61.4999C87.8 56.7999 93.6 54.8999 98.3 57.2999C103 59.6999 104.9 65.4999 102.5 70.1999L80.7 112.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3 115.3L82.4 109.2C84.8 104.5 90.6 102.6 95.3 105C100 107.4 101.9 113.2 99.5 117.9L96.4 124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1 126.5L97 122.8C99.4 118.1 105.2 116.2 109.9 118.6C114.6 121 116.5 126.8 114.1 131.5L111 137.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "arrow-group stroke-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8 47.3C53 35.6 75.5 28.8 99.6 28.8C122.3 28.8 144.1 34.9001 162.5 45.4001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 20L162.4 45.4L136.6 53.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipinghand);
export default __webpack_public_path__ + "static/media/swipinghand.6a4d161e.svg";
export { ForwardRef as ReactComponent };